import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import Response from '@/models/Response';

export default class AuthResponse extends Response {
  constructor(status: AuthResponseStatus, code: string, messageEN: string, messageNL: string) {
    super(status, code, '', messageEN, messageNL);
  }

  public static buildSuccesResponse(messageEN: string, messageNL: string, code: string = ''): AuthResponse {
    return new AuthResponse(AuthResponseStatus.SUCCESS, code, messageEN, messageNL);
  }
}
